import styled from 'styled-components';
import theme from 'styles/theme';

export const DataLinkageManageWrapper = styled.div`
  .noticeBanner {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px 0 25px;
    width: 100%;
    height: 48px;
    background: rgba(0, 159, 249, 0.1);

    span {
      font-size: 13px;
      color: #111;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .paddingWrapper {
    padding: 25px;

    & > button {
      margin: 5px 0 41px;
      display: block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      font-size: 17px;
      font-weight: ${theme.fontWeight.normal};
      text-align: center;
      border-radius: 5px;
      background: ${theme.backgroundColor.blue};
      color: ${theme.color.white};
    }

    & > p {
      margin: 200px 0;
      text-align: center;
      font-size: 15px;
      line-height: 23px;
      color: #78797c;
    }

    .listSection {
      text-align: right;

      .refreshBtn {
        padding: 7px 8px;
        border: 1px solid #dcdce4;
        border-radius: 5px;
        margin: 18px 3px;

        span {
          display: flex;
          align-items: center;
          color: #32324d;
          font-size: 12px;
          letter-spacing: -0.5px;

          &::before {
            content: '';
            display: block;
            width: 12px;
            height: 12px;
            margin-right: 5px;
            background: url(/images/icons/refresh.svg) no-repeat;
            background-size: cover;
          }
        }
      }

      & > p {
        margin: 200px 0;
        text-align: center;
        font-size: 15px;
        line-height: 23px;
        color: #78797c;
      }
    }
  }
`;
